import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { PropTypes as PropTypes$1 } from '@panneau/core';

var propTypes = {
  theme: PropTypes.string,
  delay: PropTypes.number,
  withDelay: PropTypes.bool,
  withoutCard: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes$1.label
};
var defaultProps = {
  theme: null,
  delay: 300,
  withDelay: false,
  withoutCard: false,
  className: null,
  children: null
};
var Loading = function Loading(_ref) {
  var theme = _ref.theme,
    delay = _ref.delay,
    withDelay = _ref.withDelay,
    withoutCard = _ref.withoutCard,
    className = _ref.className,
    children = _ref.children;
  var _useState = useState(!withDelay),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  useEffect(function () {
    var id = setTimeout(function () {
      setVisible(true);
    }, delay);
    return function () {
      clearTimeout(id);
    };
  }, [setVisible]);
  return visible ? /*#__PURE__*/React.createElement("div", {
    className: classNames([_defineProperty({
      card: !withoutCard
    }, className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body d-flex align-items-center justify-content-center text-muted"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(['spinner-border', _defineProperty({}, "text-".concat(theme), theme !== null)])
  }, /*#__PURE__*/React.createElement("span", {
    className: "visually-hidden"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "x27x2b",
    defaultMessage: [{
      "type": 0,
      "value": "Loading"
    }]
  }))), children !== null ? /*#__PURE__*/React.createElement("div", {
    className: classNames(['mx-2', _defineProperty({}, "text-".concat(theme), theme !== null)])
  }, children) : null)) : null;
};
Loading.propTypes = propTypes;
Loading.defaultProps = defaultProps;

export { Loading as default };
